// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__sUXiC","signatureBlock":"Footer_signatureBlock__1HdVv","signature":"Footer_signature__2otoO"};